import { CommonModule } from "@angular/common";
import { Component, computed } from "@angular/core";
import {
    ModalAdapter,
    ModalContainer,
    ModalHeader,
} from "@malirang/front-share";
import { FixDocumentContentComponent } from "./fix-document-content.component";

export type FixDocumentContentModalProps = {
    documentId: string;
};

@Component({
    selector: "app-fix-document-content-modal",
    template: `
        <section class="w-full h-full" modalContainer>
            <app-modal-header header>문서 상세</app-modal-header>
            <div class="overflow-hidden">
                <app-fix-document-content [documentId]="documentId()!" />
            </div>
        </section>
    `,
    imports: [
        CommonModule,
        ModalHeader,
        ModalContainer,
        FixDocumentContentComponent,
    ],
})
export class FixDocumentContentModal extends ModalAdapter<FixDocumentContentModalProps> {
    documentId = computed(() => this.props()?.documentId);
}
